import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './views/App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from '@/auth';
import { Provider } from 'react-redux';
import {configureStore} from './stores/rootStore';
import IStore from './models/IStore';
import { SidebarProvider } from './context/SidebarContext';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const store = configureStore({} as IStore);

const SnackbarCloseButton = ({ id }: { id: string | number }) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton
      aria-label="close"
      color="inherit"
      onClick={() => closeSnackbar(id)}
    >
      <CloseIcon />
    </IconButton>
  );
};

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <SidebarProvider>
        <Provider store={store}>
          <AuthProvider>
            <SnackbarProvider 
              iconVariant={{ error: null }} 
              maxSnack={20} 
              autoHideDuration={null}
              action={(key) => <SnackbarCloseButton id={key} />}
              >
              <App />
            </SnackbarProvider>
          </AuthProvider>
        </Provider>
      </SidebarProvider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
